import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import "./List.vue?vue&type=style&index=0&id=c6abb946&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6abb946"]])

export default __exports__